// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"Sb","mainContent":"Tb","activeSidebar":"Ub"};